module.exports = __webpack_public_path__ + "img/style_0_4.b514670d.png";